<template>
<el-card>
    <el-row type="flex" justify="center" style="margin-top:50px">
        <el-col :span="12">
            <el-autocomplete v-model="code" :fetch-suggestions="querySearch" placeholder="请输入模板关键字" @select="handleSelect">
                <template slot-scope="{ item }">
                    <div class="name">{{ item.value }}<span class="code">{{ item.code }}</span></div>
                </template>
            </el-autocomplete>
        </el-col>
    </el-row>
    <el-table size="mini" border :data="data">
        <el-table-column prop="name" label="模板参数名称" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="desc" label="说明" />
    </el-table>
</el-card>
</template>

<script>
import params from "@/data/contract-template-params"
export default {
    data() {
        return {
            code: '',
            templates: [{
                    value: '趣普拉斯定制境内合同模板',
                    code: 'QUXCN'
                },
                {
                    value: '胜千里系统定制境内合同模板',
                    code: 'ERPCN'
                }
            ],
            data: []
        }
    },
    methods: {
        querySearch(query, cb) {
            cb(this.templates)
        },
        handleSelect(value) {
            this.data = params[value.code]
        }
    }
}
</script>

<style scoped>
.el-autocomplete {
    width: 100%;
}

.name {
    text-overflow: ellipsis;
    overflow: hidden;
}

.code {
    margin-left: 20px;
    font-size: 12px;
    color: #b4b4b4;
}

.el-table {
    margin-top: 50px;
}
</style>
